module.exports = __webpack_public_path__ + "static/media/Lato-BoldItalic.acc03ac1.ttf";